import React, { useEffect } from 'react'

import { useSelector, useDispatch } from 'react-redux'

import { BottomSheet } from '@interco/inter-ui/components/BottomSheet'
import { Button } from '@interco/inter-ui/components/Button'
import { ColorWrapper, TextParagraph } from '@atoms'
import { Colors } from '@utils/Colors'
import { BridgeService } from '@services/bridge'
import Tag from '@utils/Tag'
import { ApplicationState } from '@store/types'
import { clearError } from '@store/ui/error/actions'

interface Props {
  setShowBottomSheet: React.Dispatch<React.SetStateAction<boolean>>
  variant: {
    title: string
    text: string
    button: string
  }
}

export const BottomSheetError = ({ setShowBottomSheet, variant }: Props) => {
  const dispatch = useDispatch()
  const { convenioName } = useSelector((state: ApplicationState) => state.refinanciamento.contratos)
  const { isApp } = useSelector((state: ApplicationState) => state.ui.navigation)

  useEffect(() => {
    BridgeService.tac({
      name: 'bottomsheet_error',
      actions: ['abrir_bottomsheet_error'],
    })

    if (isApp) {
      Tag.enviarTagueamentoApp({
        ref_figma: '2',
        name: '',
        screen: 'Bottomsheet Error',
        ref_type: '',
        content_action: 'Abrir',
        content_name: variant.title ?? 'Erro',
        product: convenioName,

        product_area: 'refin',
      })
    }
  }, [variant.title, convenioName, isApp])

  const handleClose = () => {
    BridgeService.tic({
      name: 'btn_fechar_error',
      action: 'fechar_bottomsheet_error',
    })

    if (isApp) {
      Tag.enviarTagueamentoApp({
        ref_figma: '2',
        name: '',
        screen: 'Bottomsheet Error',
        ref_type: 'botao',
        content_action: 'Toque',
        content_name: 'Fechar',
        product: convenioName,

        product_area: 'refin',
      })
    }

    setShowBottomSheet(false)
    setTimeout(() => {
      dispatch(clearError())
    }, 600)
  }

  return (
    <BottomSheet onClose={handleClose}>
      <ColorWrapper color={Colors.GRAY500} fontWeight="600" margin="0">
        <TextParagraph variant="headline-h3">{variant.title}</TextParagraph>
      </ColorWrapper>

      <ColorWrapper color={Colors.GRAY500} margin="0 0 16px 0">
        <TextParagraph variant="body-3" margin="0 0 16px 0">
          {variant.text}
        </TextParagraph>
      </ColorWrapper>
      <Button fullWidth onClick={handleClose} style={{ marginTop: '14px' }}>
        {variant.button}
      </Button>
    </BottomSheet>
  )
}
